import {
  Button,
  Card,
  Checkbox,
  CheckboxChangeEvent,
  Col,
  Flex,
  Form,
  Grid,
  Input,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  SelectProps,
  Tooltip,
} from "antd";
import { Cascader } from "antd-mobile";
import { CheckListValue } from "antd-mobile/es/components/check-list";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CustomMessage } from "../../../../components";
import { useLocalStorage } from "../../../../context/useLocalStorage";
import { contactMethod } from "../../../../enumerations/contactMethod";
import localStorageKey from "../../../../enumerations/localStorageKey";
import {
  useCheckout,
  useGetPaymentMethod,
  usePay,
} from "../../../../hooks/Checkout/checkout.hooks";
import {
  PaymentParams,
  PaymentResponse,
  PayResponse,
} from "../../../../hooks/Checkout/data";
import { PhoneCodeResponse } from "../../../../hooks/PhoneCode/data";
import { useGetAreaCode } from "../../../../hooks/PhoneCode/hooks";
import {
  SearchResponse,
  SearchSessionDetail,
} from "../../../../hooks/Search/data";

import {
  ExclamationCircleOutlined,
  MinusCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import AlertCircle from "../../../../assets/images/icons/AlertCircle";
import { H6, P2 } from "../../../../components/NormalFonts";
import { useAuth } from "../../../../context/AuthContext";
import apiErrorCode from "../../../../enumerations/apiErrorCode";
import contentTypeEnum from "../../../../enumerations/contentTypeEnum";
import { useCheckCoupon } from "../../../../hooks/Coupon/coupon.hooks";
import {
  CheckCouponResponse,
  ClassSessionTime,
} from "../../../../hooks/Coupon/data";
import { OrderDetailsType } from "../../../../hooks/Order/data";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { pushGtag } from "../../../../plugins/utils";
import {
  EmailFormat,
  InputRequired,
} from "../../../../validations/validations";
import { discountTypeEnum } from "../../enumerations/discountType";
import {
  carrierTypeEnum,
  receiptMethodCodeEnum,
  receiptTypeEnum,
} from "../../enumerations/receiptType";
import PaymentItem from "./components/PaymentItem";
import { PaymentProps, PriceChangedOrder } from "./data";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import styles from "./style.module.scss";
import "./styles.scss";

const Payment: React.FC<PaymentProps> = ({
  searchResult = [],
  loadingResult = {},
  onChangeStep,
  setPaymentNumber = () => {},
  paymentNumber,
  totalAmount,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { useBreakpoint } = Grid;
  const location = useLocation();
  const { nickname } = location.state || {};
  const screens = useBreakpoint();
  const { setLoginForm, setAuthModalVisible, isAuthenticated } = useAuth();
  const { toLocalTimezone, formatDate } = useGetTimezone();
  const [localStorageCoupon, setLocalStorageCoupon] = useLocalStorage(
    localStorageKey.COUPON,
    undefined
  );
  const DEFAULT_AREA_CODE = "+886";
  const DEFAULT_CONTACT_TYPE = "LINE";
  const [loading, setLoading] = useState<boolean>(false);
  const [openSelect, setOpenSelect] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [areaCodeValue, setAreaCodeValue] = useState<CheckListValue[]>([]);
  const [userInfo, setUserInfo] = useLocalStorage(
    localStorageKey.USER_INFO,
    undefined
  );
  const [useRegisterEmail, setUseRegisterEmail] = useState<boolean>(false);
  const [methodCode, setMethodCode] = useState<string>("");
  const [receiptMethodCode, setReceiptMethodCode] = useState<string>("");
  const needReceipt = [
    receiptMethodCodeEnum.ECPAY,
    receiptMethodCodeEnum.AMEGO,
  ];
  const [receiptType, setReceiptType] = useState<number>(receiptTypeEnum.NONE);
  const [paymentOptions, setPaymentOptions] = useState<SelectProps["options"]>(
    []
  );
  const [areaOptions, setAreaOptions] = useState<any[]>([]);
  const [contactOptions, setContactOptions] = useState<SelectProps["options"]>(
    []
  );
  const [checkPaymentAgreement, setCheckPaymentAgreement] =
    useState<boolean>(false);
  const [checkInfoAgreement, setCheckInfoAgreement] = useState<boolean>(true);

  const [isPaymentUnchecked, setIsPaymentUnchecked] = useState<boolean>(false);
  const [isInfoUnchecked, setIsInfoUnchecked] = useState<boolean>(false);

  const couponCodeChecked = useRef<boolean>(false);
  const [couponCode1, setCouponCode1] = useState<string>("");
  const [couponCode2, setCouponCode2] = useState<string>("");
  const [classDate, setClassDate] = useState<string[]>(["", ""]);
  const [classSessionTime, setClassSessionTime] = useState<ClassSessionTime[]>(
    []
  );

  const [shouldCheckCoupon, setShouldCheckCoupon] = useState<boolean>(false);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [totalInstructorFee, setTotalInstructorFee] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState<number>(0);
  const [currentCouponData, setCurrentCouponData] = useState<
    CheckCouponResponse | undefined
  >(undefined);

  const [showCoachDisc, setShowCoachDisc] = useState<boolean>(false);

  // 結帳頁自己維護一份訂單資料，價格變動時可以就地更新
  const [orderItems, setOrderItems] = useState<
    SearchResponse[] | OrderDetailsType[]
  >(searchResult);

  useEffect(() => {
    setOrderItems(searchResult);
  }, [searchResult]);

  const { data: paymentList, error: errorPayment } = useGetPaymentMethod({});
  const { data: phoneArea } = useGetAreaCode({});
  const { mutate: checkout } = useCheckout();
  const { mutate: pay } = usePay();
  const {
    refetch: refetchCheckCoupon,
    isFetching: isCheckingCoupon,
    error: errorChecking,
  } = useCheckCoupon(
    {
      coupon_code1: couponCode1.replace(/%/g, ""),
      coupon_code2: couponCode2.replace(/%/g, ""),
      branch_id: orderItems[0].branch_id,
      ski_resort_codes: (orderItems as SearchResponse[]).reduce(
        (
          acc: string,
          val: SearchResponse | OrderDetailsType,
          index: number
        ) => {
          return index === orderItems.length - 1
            ? acc + val.ski_resort_code
            : acc + val.ski_resort_code + ",";
        },
        "" as string
      ),
      price: (orderItems as OrderDetailsType[]).reduce(
        (acc: number, val: SearchResponse | OrderDetailsType) => {
          return acc + val.total_price;
        },
        0
      ),
      class_start_time: classDate[0],
      class_end_time: classDate[1],
      class_session_time: classSessionTime,
    },
    { enabled: false }
  );

  useEffect(() => {
    console.debug("errorChecking", errorChecking);
  }, [errorChecking]);

  const openHtmlInCurrentTab = (htmlString: string) => {
    const blob = new Blob([htmlString], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    // navigate("/record", { replace: true });
    // window.open(url, "_blank");
    window.location.href = url;

    // Optional: revoke later (browser might already do this on unload)
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  };

  const handleCheckCoupon = () => {
    if (isAuthenticated === false) {
      setAuthModalVisible(true);
      return;
    }

    refetchCheckCoupon()
      .then((data: any) => {
        if (data.status === "error") {
          const code = data.error?.data?.result?.code ?? data.error?.data?.code;
          const message =
            data.error?.data?.result?.message ?? data.error?.data?.message;
          const coupons =
            data.error?.data?.result?.coupon_code ??
            data.error?.data?.coupon_code;
          if (
            code === apiErrorCode.TOKEN_ERROR ||
            code === apiErrorCode.AUTH_FAIELD_ERROR
          ) {
            setAuthModalVisible(true);
          }

          CustomMessage({
            alertMessage: t([`error.${code}`, message], {
              coupon_ids: coupons,
            }),
            alertType: "error",
          });
        } else if (data.status === "success") {
          console.debug("data.data.dicount", data.data.discount_value);
          console.debug("totalPrice", totalPrice);
          if (
            data.data.discount_type === discountTypeEnum.MONEY &&
            data.data.discount_value > (totalPrice || 0)
          ) {
            form.setFields([
              {
                name: "coupon_code",
                errors: [t("error.discount")],
              },
            ]);
            console.debug("error", "error discount to big");
            return;
          }
          setCurrentCouponData(data.data.coupon);
          couponCodeChecked.current = true;
        }
      })
      .catch((error) => {
        console.debug("err", error);
      });
  };

  const handleCouponCode1Change = (e: any) => {
    setCouponCode1(e.target.value);
    setCurrentCouponData(undefined);
    couponCodeChecked.current = false;

    // 清除优惠券代码的错误提示
    form.setFields([
      {
        name: "coupon_code1",
        errors: [],
      },
    ]);
  };

  const handleCouponCode2Change = (e: any) => {
    setCouponCode2(e.target.value);
    setCurrentCouponData(undefined);
    couponCodeChecked.current = false;

    // 清除优惠券代码的错误提示
    form.setFields([
      {
        name: "coupon_code2",
        errors: [],
      },
    ]);
  };

  useEffect(() => {
    if (currentCouponData) {
      if (currentCouponData.discount_type === discountTypeEnum.MONEY) {
        setDiscountAmount(currentCouponData.discount_value);
        setFinalTotalAmount(totalPrice - currentCouponData.discount_value);
      } else {
        const discountPrice =
          (totalPrice - totalInstructorFee) *
          (currentCouponData.discount_value / 100);
        setDiscountAmount(discountPrice);
        setFinalTotalAmount(totalPrice - discountPrice);
      }
    }
  }, [currentCouponData, isCheckingCoupon]);

  useEffect(() => {
    setContactOptions(
      contactMethod.map((contact: any) => {
        return {
          label: t(`normal.contact.${contact.value}`),
          value: contact.value,
        };
      })
    );
    form.setFieldsValue({
      contact_type: contactMethod[0].value,
    });
  }, []);

  useEffect(() => {
    if (!paymentList || paymentList.length <= 0) return;
    const _payment = paymentList.map((payment: PaymentResponse) => {
      return {
        label: t(`payment.method.code.${payment.payment_method_code}`),
        value: payment.payment_method_code,
        receipt_method_code: payment.receipt_method_code,
      };
    });
    form.setFieldsValue({
      payment_method_code: paymentList[0].payment_method_code,
    });
    setMethodCode(paymentList[0].payment_method_code);
    setReceiptMethodCode(paymentList[0].receipt_method_code);
    setPaymentOptions(_payment);
  }, [paymentList]);

  const formatOrderDate = (sessions: SearchSessionDetail[] = []) => {
    if (sessions.length <= 0) return "";
    const first = formatDate(toLocalTimezone(sessions[0].date));
    if (sessions.length === 1) return first;
    return `${first} - ${toLocalTimezone(
      sessions[sessions.length - 1].date
    )?.format(`MM${t("format.date.month")}DD${t("format.date.date")}`)}`;
  };

  // 後端回傳價格已更新：換成新價格、清掉已套用的優惠券，請客人確認後再送出
  const handlePriceChanged = (changedOrders: PriceChangedOrder[] = []) => {
    const hadCoupon = !!currentCouponData;
    const currency = t(`currency.${process.env.REACT_APP_CURRENCY}`);

    const updatedItems = (orderItems as SearchResponse[]).map(
      (item: SearchResponse, index: number) => {
        const changed = changedOrders.find(
          (order: PriceChangedOrder) => order.index === index
        );
        if (!changed) return item;
        return {
          ...item,
          total_price: changed.total_price,
          order_price: changed.total_price,
          session_details: item.session_details?.map(
            (detail: SearchSessionDetail) => {
              const newDetail = changed.session_details.find(
                (d) => String(d.session_id) === String(detail.session_id)
              );
              return newDetail ? { ...detail, ...newDetail } : detail;
            }
          ),
        };
      }
    );

    setOrderItems(updatedItems);
    setCurrentCouponData(undefined);
    setDiscountAmount(0);
    couponCodeChecked.current = false;

    Modal.confirm({
      title: t("checkout.priceChanged.title", "課程價格已更新"),
      icon: null,
      content: (
        <Flex vertical gap={8}>
          <P2>{t(
              "checkout.priceChanged.content",
              "以下課程的價格已更新，請確認新價格後再送出訂單。"
            )}</P2>
          {changedOrders.map((changed: PriceChangedOrder) => {
            const item = (orderItems as SearchResponse[])[changed.index];
            return (
              <P2 key={`price_changed_${changed.index}`} weight="medium">
                {`${formatOrderDate(item?.session_details)}：${currency} ${moneyFormat(
                  changed.old_total_price
                )} → ${currency} ${moneyFormat(changed.total_price)}`}
              </P2>
            );
          })}
          {hadCoupon && (
            <P2 color="var(--primary)">
              {t(
                "checkout.priceChanged.couponReset",
                "因金額變動，已套用的優惠券已清除，請重新套用。"
              )}
            </P2>
          )}
        </Flex>
      ),
      okText: t("normal.understand"),
      cancelButtonProps: { style: { display: "none" } },
    });
  };

  const onFinish = async (value: any) => {
    console.debug("currentCouponData", currentCouponData);
    if (isAuthenticated === false) {
      setAuthModalVisible(true);
      return;
    }

    setIsInfoUnchecked(!checkInfoAgreement);
    setIsPaymentUnchecked(!checkPaymentAgreement);
    if (!checkInfoAgreement || !checkPaymentAgreement) return;

    // setLoading(true);
    const receiptRequest = {
      receipt_type:
        receiptType === receiptTypeEnum.NONE
          ? receiptTypeEnum.CARRIER
          : receiptType,
      carrier_type:
        receiptType === receiptTypeEnum.CARRIER
          ? carrierTypeEnum.MOBILE
          : carrierTypeEnum.NONE,
      carrier_num:
        receiptType === receiptTypeEnum.CARRIER
          ? `/${value.carrier_num}`
          : undefined,
      user_company:
        receiptType === receiptTypeEnum.IDENTIFIER
          ? {
              customer_identifier: value.customer_identifier,
              name: value.name,
              addr: value.addr,
            }
          : undefined,
    };
    if (!paymentNumber) {
      const request = {
        // company_code: process.env.REACT_APP_COMPANY_CODE,
        total_order_amount: totalPrice,
        orderer_name: value.orderer_name,
        orderer_email: value.orderer_email,
        orderer_area_code: value.orderer_area_code,
        // orderer_area_code: "866",
        orderer_mobile: value.orderer_mobile,
        orderer_contact: [
          {
            contact_type: value.contact_type,
            contact_value: value.contact_value,
          },
        ],
        payment_method_code: value.payment_method_code,
        order_list: orderItems,
        coupon_code1:
          currentCouponData && value?.coupon_code1
            ? value.coupon_code1.replace(/%/g, "")
            : "",
        coupon_code2:
          currentCouponData && value?.coupon_code2
            ? value.coupon_code2.replace(/%/g, "")
            : "",
        discount_amount: currentCouponData ? discountAmount : 0,
        final_total_amount: finalTotalAmount,
      };

      const finalRequest = needReceipt.includes(receiptMethodCode)
        ? { ...request, ...receiptRequest }
        : request;
      // console.debug("finalRequest", finalRequest);
      await checkout(
        { params: finalRequest },
        {
          onSuccess: async (data: any) => {
            pushGtag({
              event: "go_to_payment",
            });

            const response: PayResponse = data?.data?.data?.payment_detail;
            setLoading(false);
            switch (response.content_type) {
              case contentTypeEnum.HTML:
                openHtmlInCurrentTab(response.content);
                break;

              default:
                break;
            }
          },
          onError: (error: any) => {
            if (error.data.result.code === apiErrorCode.PRICE_CHANGED) {
              handlePriceChanged(error.data.result.price_changed_orders);
              setLoading(false);
              return;
            }
            if (
              error.data.result.code === apiErrorCode.TOKEN_ERROR ||
              error.data.result.code === apiErrorCode.AUTH_FAIELD_ERROR
            ) {
              setAuthModalVisible(true);
            }
            CustomMessage({
              alertMessage: t([
                `error.${error.data.result.code}`,
                error.data.result.message,
              ]),
              alertType: "error",
            });
            setLoading(false);
          },
        }
      );
    } else {
      const request: PaymentParams = {
        payment_method_code: value.payment_method_code,
        order_payment_number: paymentNumber,
        total_price: Number(totalAmount),
        orderer_name: value.orderer_name,
        orderer_area_code: value.orderer_area_code,
        orderer_mobile: value.orderer_mobile,
        orderer_email: value.orderer_email,
      };
      const finalRequest = needReceipt.includes(receiptMethodCode)
        ? { ...request, ...receiptRequest }
        : request;
      console.debug("finalRequest", finalRequest);
      pay(
        { params: finalRequest },
        {
          onSuccess: (data: any) => {
            const response: PayResponse = data.data.data;
            setLoading(false);
            switch (response.content_type) {
              case contentTypeEnum.HTML:
                openHtmlInCurrentTab(response.content);
                break;
              default:
                break;
            }
          },
          onError: (error: any) => {
            console.debug("error", error);
            setLoading(false);
            CustomMessage({
              alertMessage: t([
                `error.${error.data.result.code}`,
                error.data.result.message,
              ]),
              alertType: "error",
            });
          },
        }
      );
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    // 如果有驗證錯誤，跳轉到第一個錯誤的字段
    if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
      const firstErrorField = errorInfo.errorFields[0];

      form.scrollToField(firstErrorField.name, {
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  };

  const onCheckRegisterEmailChange = (e: CheckboxChangeEvent) => {
    setUseRegisterEmail(e.target.checked);
    if (e.target.checked === true) {
      form.setFieldsValue({ orderer_email: userInfo?.email });
    } else {
      form.setFieldsValue({ orderer_email: undefined });
    }
  };

  const onAgreementCheckChange = (e: CheckboxChangeEvent) => {
    setCheckPaymentAgreement(e.target.checked);
    setIsPaymentUnchecked(!e.target.checked);
  };
  const onInfoCheckChange = (e: CheckboxChangeEvent) => {
    setCheckInfoAgreement(e.target.checked);
    setIsInfoUnchecked(!e.target.checked);
  };

  useEffect(() => {
    if (!phoneArea || phoneArea.length <= 0) return;
    const _area = phoneArea.map((area: PhoneCodeResponse) => {
      return {
        label: `+${area.phoneCode}`,
        value: area.phoneCode,
      };
    });
    const areaCode = userInfo?.area_code
      ? userInfo.area_code.toString()
      : DEFAULT_AREA_CODE;
    form.setFieldsValue({
      orderer_area_code: areaCode,
    });
    setAreaCodeValue([areaCode]);
    setAreaOptions(_area);
  }, [phoneArea]);

  useEffect(() => {
    if (!userInfo) return;
    form.setFieldsValue({
      orderer_mobile: userInfo?.mobile,
      contact_type:
        userInfo?.contact && userInfo.contact.length > 0
          ? userInfo?.contact[0].contact_type
          : DEFAULT_CONTACT_TYPE,
      contact_value:
        userInfo?.contact && userInfo.contact.length > 0
          ? userInfo?.contact[0].contact_value
          : undefined,
      orderer_name: userInfo?.nickname,
      orderer_email: userInfo?.email,
    });
    if (userInfo?.email) {
      setUseRegisterEmail(true);
    }
  }, [userInfo]);

  const handleClickAreaCode = () => {
    if (screens.sm) {
      setOpenSelect(!openSelect);
      setOpenPopup(false);
    } else {
      setOpenSelect(false);
      setOpenPopup(true);
    }
  };

  const handleConfirmAreaCode = (val: CheckListValue[]) => {
    console.debug(val);
    if (val.length > 0) {
      form.setFieldsValue({
        orderer_area_code: val[0],
      });
      setAreaCodeValue(val);
    }
  };

  const areaSelector = (
    <Form.Item name={"orderer_area_code"} style={{ marginBottom: 0 }}>
      <Select
        style={{ width: 120 }}
        options={areaOptions}
        open={openSelect}
        onClick={handleClickAreaCode}
        onChange={(val) => setAreaCodeValue([val])}
      />
    </Form.Item>
  );

  const contactSelector = (
    <Form.Item name={"contact_type"} style={{ marginBottom: 0 }}>
      <Select style={{ width: 120 }} options={contactOptions} />
    </Form.Item>
  );
  const renderContactExtra = () => {
    return (
      <>
        <Tooltip
          classNames={{ root: "custom-tooltip" }}
          placement={"bottomRight"}
          align={{ offset: [-50, 0], autoArrow: true }}
          styles={{
            body: {
              borderRadius: 4,
              background: "#FFF",
              boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.10)",
              padding: "2px 16px",
              width: 322,
            },
            root: {
              background: "#FFF",
            },
          }}
          title={
            <P2 color="var(--Neutral-dark-70)">
              <Trans
                i18nKey={"order.hint"}
                components={{
                  ol: <ol />,
                  li: <li />,
                }}
              />
            </P2>
          }
        >
          <AlertCircle style={{ fontSize: 20, color: "var(--primary)" }} />
        </Tooltip>
        <div></div>
      </>
    );
  };

  const renderPaymentItem = () => {
    let visibleData: SearchResponse[] | OrderDetailsType[] = orderItems;
    // console.debug("visibleData", visibleData);
    return visibleData?.map(
      (result: SearchResponse | OrderDetailsType, index: number) => {
        return (
          <PaymentItem
            order={result}
            key={`order_${index}`}
            nickname={nickname}
          />
        );
      }
    );
  };

  const handleRemoveCoupon2 = () => {
    setCouponCode2("");
    form.setFieldsValue({ coupon_code2: undefined });
    setShowCoachDisc(false);
  };

  const renderCoachDiscount = () => {
    if (showCoachDisc === false)
      return (
        <Col span={24}>
          <Button
            type="link"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => setShowCoachDisc(true)}
          >
            {t("button.addCoachDiscount")}
          </Button>
        </Col>
      );
    return (
      <>
        <Col span={screens.md ? 21 : 24}>
          <Form.Item name="coupon_code2" noStyle>
            <Input
              placeholder={t("coachDiscount.hint")}
              value={couponCode2}
              onChange={handleCouponCode2Change}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col
          span={screens.md ? 3 : 24}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            type="link"
            size="small"
            icon={<MinusCircleFilled />}
            shape="circle"
            onClick={handleRemoveCoupon2}
          />
        </Col>
      </>
    );
  };

  const renderDiscount = () => {
    if (paymentNumber) return;
    return (
      <Card
        style={{ width: "100%" }}
        variant={"borderless"}
        size={screens.sm ? "default" : "small"}
        title={<div>{t("search.payment.useCoupon")}</div>}
      >
        <Row gutter={screens.md ? [16, 14] : [0, 4]}>
          <Col span={screens.md ? 21 : 24}>
            <Form.Item
              name="coupon_code1"
              label={t("search.payment.coupon")}
              noStyle
            >
              <Input
                placeholder={t("search.payment.coupon.placeholder")}
                value={couponCode1}
                onChange={handleCouponCode1Change}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col
            span={screens.md ? 3 : 24}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              size="small"
              style={{ width: "100%", height: screens.md ? 46 : 36 }}
              onClick={handleCheckCoupon}
              disabled={
                (!couponCode1 && !couponCode2) || couponCodeChecked.current
              }
              loading={isCheckingCoupon}
            >
              {t("search.payment.coupon.check")}
            </Button>
          </Col>
          {/* {renderCoachDiscount()} */}
          {currentCouponData && (
            <Col span={24}>
              <div
                className={styles.couponResult}
                style={{
                  marginTop: screens.md ? 0 : 34,
                  justifyContent: screens.md ? "flex-end" : "space-between",
                }}
              >
                <Flex
                  vertical
                  justify="flex-end"
                  gap={8}
                  style={{ textAlign: screens.md ? "end" : "start" }}
                >
                  <P2 color="var(--text-content-3)">
                    {t("search.payment.coupon.totalPrice")}
                  </P2>
                  <P2 color="var(--text-content-3)">
                    <Flex gap={4}>
                      <Tooltip title={t("search.payment.coupon.hint")}>
                        <ExclamationCircleOutlined />
                      </Tooltip>
                      <div>{t("search.payment.coupon.discountPrice")}</div>
                    </Flex>
                  </P2>
                  <P2
                    color="var(--text-content-3)"
                    style={{
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {t("search.payment.coupon.finalPrice")}
                  </P2>
                </Flex>
                <Flex
                  vertical
                  justify="flex-end"
                  gap={8}
                  style={{ textAlign: "end" }}
                >
                  <P2 weight="medium" color="var(--text-content-1)">
                    {`${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(totalPrice)}`}
                  </P2>
                  <P2 weight="medium" color="var(--text-content-1)">
                    {`- ${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(discountAmount)}`}
                  </P2>
                  <H6 weight="heavy" color="var(--primary)">
                    {`${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(finalTotalAmount)}`}
                  </H6>
                </Flex>
              </div>
            </Col>
          )}
        </Row>
      </Card>
    );
  };

  const renderReceiptForm = () => {
    switch (receiptType) {
      case receiptTypeEnum.CARRIER:
        return (
          <Row>
            <Col span={24}>
              <Form.Item
                name="carrier_num"
                label={t("receiptType.carrier.carrierNum")}
                rules={[InputRequired(t, "receiptType.carrier.carrierNum")]}
              >
                <Input
                  className="carrier-num-input"
                  placeholder={t("receiptType.carrier.carrierNum.placeholder")}
                  addonBefore={
                    <div style={{ padding: "0 4px 0 2px", marginBottom: 2 }}>
                      /
                    </div>
                  }
                  onChange={(e: any) => {
                    const upper = e.target.value.toUpperCase();
                    form.setFieldsValue({ carrier_num: upper });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        );
      case receiptTypeEnum.IDENTIFIER:
        return (
          <Row>
            <Col span={24}>
              <Form.Item
                name="customer_identifier"
                label={t("result.payment.receiptType.identifier")}
                rules={[
                  InputRequired(t, "result.payment.receiptType.identifier"),
                ]}
              >
                <Input placeholder={t("receiptType.identifier.placeholder")} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="name"
                label={t("receiptType.identifier.companyName")}
                rules={[InputRequired(t, "receiptType.identifier.companyName")]}
              >
                <Input
                  placeholder={t(
                    "receiptType.identifier.companyName.placeholder"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="addr"
                label={t("receiptType.identifier.companyAddress")}
                rules={[
                  InputRequired(t, "receiptType.identifier.companyAddress"),
                ]}
              >
                <Input
                  placeholder={t(
                    "receiptType.identifier.companyAddress.placeholder"
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    console.debug("SEARCH_RESULT", orderItems);
    if (orderItems.length > 0) {
      const newTotalPrice: number = (orderItems as OrderDetailsType[]).reduce(
        (acc: number, val: SearchResponse | OrderDetailsType) => {
          return acc + val.total_price;
        },
        0
      );
      let newTotalInstructorFee: number = 0;
      const classDateArray: string[] = [];
      const classSessionTimeArray: ClassSessionTime[] = [];
      orderItems.map((item: SearchResponse | OrderDetailsType) => {
        classDateArray.push(item.start_date, item.end_date);
        classSessionTimeArray.push({
          start: item.start_date,
          end: item.end_date,
        });
        if (item.session_details) {
          item.session_details.map((session: SearchSessionDetail) => {
            newTotalInstructorFee += session.instructor_fee;
          });
        }
      });

      // 找出最早和最晚的時間
      if (classDateArray.length > 0) {
        const sortedDates = classDateArray.sort(
          (a, b) => new Date(a).getTime() - new Date(b).getTime()
        );
        const earliestDate = sortedDates[0];
        const latestDate = sortedDates[sortedDates.length - 1];
        setClassDate([earliestDate, latestDate]);
      } else {
        setClassDate([]);
      }
      setClassSessionTime(classSessionTimeArray);

      setTotalPrice(newTotalPrice);
      setTotalInstructorFee(newTotalInstructorFee);
      setFinalTotalAmount(newTotalPrice);
    }
  }, [orderItems]);

  useEffect(() => {
    if (!localStorageCoupon) return;
    if (localStorageCoupon.time < Date.now()) {
      localStorage.removeItem(localStorageKey.COUPON);
    } else {
      setCouponCode1(localStorageCoupon.data);
      form.setFieldsValue({
        coupon_code: localStorageCoupon.data,
      });
      setShouldCheckCoupon(true);
    }
  }, [localStorageCoupon]);

  // 当 couponCode 更新后，自动检查优惠券
  useEffect(() => {
    if (
      shouldCheckCoupon &&
      couponCode1 &&
      classDate[0] !== "" &&
      classDate[1] !== ""
    ) {
      handleCheckCoupon();
      setShouldCheckCoupon(false);
    }
  }, [couponCode1, shouldCheckCoupon, classDate]);

  return (
    <Form
      autoComplete={"off"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      form={form}
      requiredMark={false}
      layout={"vertical"}
    >
      <div
        className={`${styles.paymentContainer} ${
          screens.sm ? "" : styles.mobile
        }`}
      >
        {renderPaymentItem()}

        {/* 使用優惠卷 */}
        {renderDiscount()}

        {/* 主要聯絡人資訊 */}
        <Card
          style={{ width: "100%" }}
          variant={"borderless"}
          size={screens.sm ? "default" : "small"}
          title={<div>{t("checkout.contactperson.title")}</div>}
          extra={renderContactExtra()}
        >
          <Row gutter={screens.sm ? [16, 28] : [0, 0]}>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_name"
                name="orderer_name"
                label={t("checkout.nickname.title")}
                rules={[InputRequired(t, "checkout.nickname.title")]}
              >
                <Input placeholder={t("checkout.nickname.hint")} />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="contact_value"
                name="contact_value"
                label={t("checkout.contact.title")}
                rules={[
                  InputRequired(t, "checkout.contact.title"),
                  {
                    pattern: /^[\x20-\x7E]*$/, // ASCII range: space to tilde
                    message: t("error.contact.format"),
                  },
                ]}
              >
                <Input
                  addonBefore={contactSelector}
                  placeholder={t("checkout.contact.hint")}
                />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_mobile"
                name="orderer_mobile"
                label={t("checkout.phone.title")}
                rules={[
                  InputRequired(t, "checkout.phone.title"),
                  { min: 8, message: t("error.mobile.limit") },
                  { pattern: /^\d+$/, message: t("error.mobile.numberonly") },
                ]}
              >
                <Input
                  addonBefore={areaSelector}
                  placeholder={t("checkout.phone.hint")}
                />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_email"
                name="orderer_email"
                label={t("checkout.email.title")}
                rules={[
                  InputRequired(t, "checkout.email.title"),
                  EmailFormat(t),
                ]}
              >
                <Input
                  disabled={useRegisterEmail === true}
                  placeholder={t("checkout.email.hint")}
                />
              </Form.Item>
              <Checkbox
                checked={useRegisterEmail}
                className="register-checkbox"
                onChange={onCheckRegisterEmailChange}
              >
                {t("checkout.email.useregistered")}
              </Checkbox>
            </Col>
          </Row>
        </Card>

        {/* 付款方式 */}
        <Card
          style={{ width: "100%" }}
          variant={"borderless"}
          size={screens.sm ? "default" : "small"}
          title={<div>{t("checkout.paymentmethod.title")}</div>}
        >
          <Row>
            <Col span={24}>
              <Form.Item name="payment_method_code">
                <Select
                  options={paymentOptions}
                  value={methodCode}
                  onChange={(value: string, option: any) => {
                    setMethodCode(value);
                    setReceiptMethodCode(option.receipt_method_code);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* 發票類型 */}
        {needReceipt.includes(receiptMethodCode) && (
          <Card
            style={{ width: "100%" }}
            variant={"borderless"}
            size={screens.sm ? "default" : "small"}
            title={<div>{t("result.payment.receiptType")}</div>}
          >
            <Row>
              <Col span={24}>
                <Form.Item name="receipt_type">
                  <Radio.Group
                    name="radiogroup"
                    defaultValue={receiptTypeEnum.NONE}
                    value={receiptType}
                    onChange={(e: RadioChangeEvent) => {
                      setReceiptType(e.target.value);
                    }}
                    options={[
                      {
                        value: receiptTypeEnum.NONE,
                        label: t("result.payment.receiptType.none"),
                      },
                      {
                        value: receiptTypeEnum.CARRIER,
                        label: t("result.payment.receiptType.carrier"),
                      },
                      {
                        value: receiptTypeEnum.IDENTIFIER,
                        label: t("result.payment.receiptType.identifier"),
                      },
                    ]}
                    className={styles.receiptRadioGroup}
                  />
                </Form.Item>
                {renderReceiptForm()}
              </Col>
            </Row>
          </Card>
        )}

        {/* 同意條款 */}
        <div className={styles.checkContainer}>
          <Checkbox
            className={`${isPaymentUnchecked ? styles.red : ""}`}
            checked={checkPaymentAgreement}
            onChange={onAgreementCheckChange}
          >
            <Flex align="center">
              {t("checkout.terms.agreement1")}
              <a href="/guide" target="_blank">
                <P2 color="var(--primary)" style={{ lineHeight: "22px" }}>
                  {t("header.menu.guide")}
                </P2>
              </a>
              {t("checkout.terms.agreement2")}
            </Flex>
          </Checkbox>
          <Checkbox
            className={`${isInfoUnchecked ? styles.red : ""}`}
            checked={checkInfoAgreement}
            onChange={onInfoCheckChange}
          >
            {t("checkout.information.agreement", {
              name: process.env.REACT_APP_PROD_NAME_DISPLAY,
            })}
          </Checkbox>
        </div>
        <Button
          className={styles.buttonPay}
          type={"primary"}
          htmlType={"submit"}
          loading={loading}
        >
          {t("checkout.step.pay")}
        </Button>
      </div>
      <Cascader
        options={areaOptions}
        visible={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        value={areaCodeValue}
        onConfirm={handleConfirmAreaCode}
        confirmText={t("normal.confirm")}
        cancelText={t("normal.cancel")}
        placeholder={t("normal.pleaseSelect")}
      />
    </Form>
  );
};

export default Payment;
